import axiosInstance, { getApiBaseUrl } from './axiosInstance'
import OrderDirection from '../types/OrderDirection'
import Roles from '../types/Roles'
import User, { AccountStatus } from '../types/User'
import { TrainingSession } from '../pages/TrainingSessions/TrainingSessionsTable/utils'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const listUsers = (
  limit: number,
  order: OrderDirection,
  orderBy: string,
  role: string,
  search: string,
  offset: number
) => {
  const roleFilter = role !== Roles.ALL ? `&role=${role}` : ''
  const searchFilter = search ? `&search=${search}` : ''

  return axiosInstance.get<User[]>(
    `/api/admin/user/list?limit=${limit.toString()}&offset=${offset.toString()}&orderby=${orderBy}&order=${order}${roleFilter}${searchFilter}`
  )
}

const downloadUsersCsv = () => {
  const apiBaseUrl = getApiBaseUrl()
  window.open(`${apiBaseUrl}/api/admin/user/csv`, '_blank')
}

const editUser = (
  id: string | number,
  firstName: string,
  lastName: string,
  accountStatus: AccountStatus,
  role: Roles,
  subscription: boolean,
  elevated: boolean
) => {
  return axiosInstance.put(`/api/admin/user/update/${id}`, {
    firstName,
    lastName,
    role,
    accountStatus,
    subscription,
    elevated,
  })
}

const deleteUser = (userId: string | number) => {
  return axiosInstance.delete(`/api/admin/user/delete/${userId}`, {
    withCredentials: true,
  })
}

const getUserPlan = ({
  userId,
  planId,
  source = '',
}: {
  userId: number | string
  planId: number | string
  source: string
}) => {
  return axiosInstance.get<TrainingSession[]>(
    `/api/admin/user/${userId}/plans/${planId}/sessions?source=${source}`
  )
}

const usersApi = {
  listUsers,
  downloadUsersCsv,
  editUser,
  deleteUser,
  getUserPlan,
}

export default usersApi
